import { LinkedIn } from '@mui/icons-material';
import type { ImageResponse } from '@on3/api';
import clsx from 'clsx';
import { ResizedImage } from 'components/Image/ResizedImage';
import { Instagram } from 'components/Svg/Instagram';
import { TikTok } from 'components/Svg/TikTok';
import { Twitter } from 'components/Svg/Twitter';
import { YouTube } from 'components/Svg/YouTube';
import { SidebarContainer } from 'components/UI/Layout/Containers/Sidebar/SidebarContainer/SidebarContainer';
import { TextLink } from 'components/UI/Link/TextLink';

import styles from './SocialConnect.module.scss';

interface ISocialConnectProps {
  title?: string | null;
  name?: string | null;
  defaultAsset?: ImageResponse;
  twitterHandle?: string | null;
  youtubeHandle?: string | null;
  tikTokHandle?: string | null;
  instagramHandle?: string | null;
  linkedInHandle?: string | null;
  websiteUrl?: string | null;
  websiteName?: string | null;
  className?: string;
}
export const SocialConnect = ({
  title,
  youtubeHandle,
  tikTokHandle,
  instagramHandle,
  twitterHandle,
  linkedInHandle,
  defaultAsset,
  name,
  websiteUrl,
  websiteName,
}: ISocialConnectProps) => {
  const noImage = !defaultAsset?.source;

  return (
    <SidebarContainer title={title ?? 'social connect'}>
      <div className={clsx(styles.container, { [styles.noImage]: noImage })}>
        {defaultAsset?.source && (
          <ResizedImage
            className={styles.logo}
            {...defaultAsset}
            altText={`${name ?? 'Organization'} Logo`}
            fit="cover"
            height={50}
            quality={90}
            width={50}
          />
        )}
        <div className={styles.handlesContainer}>
          {twitterHandle && (
            <div className={styles.handle}>
              <Twitter className={styles.socialIcon} />
              <TextLink
                className={styles.handleLink}
                href={`https://twitter.com/${twitterHandle}`}
                rel="noopener noreferrer"
                target="_blank"
                underline="none"
              >
                @{twitterHandle}
              </TextLink>
            </div>
          )}
          {instagramHandle && (
            <div className={styles.handle}>
              <Instagram className={styles.socialIcon} />
              <TextLink
                className={styles.handleLink}
                href={`https://www.instagram.com/${instagramHandle}/`}
                rel="noopener noreferrer"
                target="_blank"
                underline="none"
              >
                @{instagramHandle}
              </TextLink>
            </div>
          )}
          {tikTokHandle && (
            <div className={styles.handle}>
              <TikTok className={styles.socialIcon} />
              <TextLink
                className={styles.handleLink}
                href={`https://www.tiktok.com/@${tikTokHandle}`}
                rel="noopener noreferrer"
                target="_blank"
                underline="none"
              >
                @{tikTokHandle}
              </TextLink>
            </div>
          )}
          {linkedInHandle && (
            <div className={styles.handle}>
              <LinkedIn className={styles.socialIcon} />
              <TextLink
                className={styles.handleLink}
                href={`${linkedInHandle}`}
                rel="noopener noreferrer"
                target="_blank"
                underline="none"
              >
                {name}
              </TextLink>
            </div>
          )}
          {youtubeHandle && (
            <div className={styles.handle}>
              <YouTube className={styles.socialIcon} />
              <TextLink
                className={styles.handleLink}
                href={`https://www.youtube.com/channel/${youtubeHandle}`}
                rel="noopener noreferrer"
                target="_blank"
                underline="none"
              >
                {name}
              </TextLink>
            </div>
          )}
        </div>
        <TextLink
          className={styles.siteLink}
          href={websiteUrl}
          rel="noopener noreferrer"
          target="_blank"
          underline="none"
        >
          {websiteName}
        </TextLink>
      </div>
    </SidebarContainer>
  );
};
